<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <div class="row mt-4">
        <div class="col">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">{{(lpProfileId) ? 'Edit' : 'Add'}} LP Profile</h3>
            </div>
            <v-stepper v-model="e1" light>
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" step="1" editable>LP Profile Details</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 2" step="2" @click="updateValidate" :editable="lpProfileId ? true : false">LP Profile Image</v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content class="v-form-body" step="1">
                  <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">
                    <v-row>
                      <v-col cols="6">
                        <label class="form-control-label">
                          Name
                          <span class="red--text">*</span>
                        </label>
                        <v-text-field
                          v-model="lpProfile.name"
                          placeholder="Enter LP Profile Name"
                          :rules="[(v) => !!v || 'Title is required!', (v) => v && !!v.trim() || 'Field cannot be blank']"
                          required
                          solo
                        ></v-text-field>
                      </v-col>
                     
                      <v-col cols="6">
                        <label class="form-control-label">
                          Website
                          <span class="red--text">*</span>
                        </label>
                        <v-text-field
                          v-model="lpProfile.website"
                          solo
                          label="Enter Website"
                          :rules="validateUrl"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="6">
                          <label class="form-control-label">
                            Nationality
                            <span class="red--text">*</span>
                          </label>
                          <v-text-field
                            v-model="lpProfile.nationality"
                            solo
                            label="Nationality"
                            :rules="[(v) => !!v || 'Nationality is required!', (v) => v && !!v.trim() || 'Field cannot be blank']"
                          ></v-text-field>
                        </v-col>

                         <v-col cols="6">
                          <label class="form-control-label">
                            Cultivation Location
                            <span class="red--text">*</span>
                          </label>
                          <v-text-field
                            v-model="lpProfile.cultivationLocation"
                            solo
                            label="Enter Cultivation Location"
                            :rules="[(v) => !!v || 'Cultivation Location is required!', (v) => v && !!v.trim() || 'Field cannot be blank']"
                          ></v-text-field>
                        </v-col>

                        <!-- <v-col cols="6">
                          <label class="form-control-label">
                            Production Facility
                            <span class="red--text">*</span>
                          </label>
                          <v-text-field
                            v-model="lpProfile.productionFacility"
                            solo
                            label="Enter Production Facility"
                            :rules="[(v) => !!v || 'Production Facility is required!']"
                          ></v-text-field>
                        </v-col> -->

                        <v-col cols="6">
                          <label class="form-control-label">
                            Range
                            <span class="red--text">*</span>
                          </label>
                          <v-text-field
                            v-model="lpProfile.range"
                            solo
                            label="Enter Range"
                            :rules="[(v) => !!v || 'Range Facility is required!',(v) => v && !!v.trim() || 'Field cannot be blank']"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                          <label class="form-control-label">
                            About
                          </label>
                          <quill-editor
                            v-model="lpProfile.description"
                            ref="myQuillEditor"
                            :options="editorOption"
                          ></quill-editor>
                        </v-col>

                        <v-col cols="6">
                          <v-card-title class="pt-8 pr-0 justify-start">
                            <h4>Active</h4>
                            <v-switch class="pl-4 pt-3 mt-0" v-model="lpProfile.isActive" flat:label="Yes" inset></v-switch>
                          </v-card-title>
                        </v-col>

                        <!-- <v-col cols="6">
                          <v-card-title class="pt-8 pr-0 justify-start">
                            <h4>Favourite?</h4>
                            <v-switch class="pl-4 pt-3 mt-0" v-model="lpProfile.isFavourite" flat:label="Yes" inset></v-switch>
                          </v-card-title>
                        </v-col> -->

                      <v-col class="text-right" cols="12">
                        <v-btn color="#989898" class="mr-4 white--text" @click="cancel">Cancel</v-btn>
                        <v-btn
                          v-if="!lpProfileId"
                          :disabled="!valid"
                          :loading="loading"
                          color="#344452"
                          class="white--text"
                          @click="saveValidate"
                        >Next</v-btn>
                        <v-btn
                          v-if="lpProfileId"
                          :disabled="!valid"
                          :loading="loading"
                          color="#344452"
                          class="white--text"
                          @click="updateValidate"
                        >Next</v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-stepper-content>

                <v-stepper-content class="v-form-body" step="2">
                  <v-row>
                    <v-col :class="$vuetify.breakpoint.mdAndUp ? 'col-6' : 'col-12'" class="pa-5">
                      <v-card>
                        <v-card-title>
                          <span class="Subtitle 1">Upload LP Profile Image</span>
                        </v-card-title>
                        <v-card-text>
                          <vue-dropzone
                            class="vue-dropzone-box"
                            ref="myVueDropzone"
                            id="dropzone"
                            :destroyDropzone="false"
                            :options="dropzoneOptions"
                            @vdropzone-sending="beforecomplete"
                            @vdropzone-success="aftercomplete"
                            @vdropzone-mounted="uploadedImage"
                            @vdropzone-removed-file="removeFile"
                            :useCustomSlot="true"
                            :useCustomDropzoneOptions="true"
                          >
                            <div class="dropzone-custom-content">
                              <img src="@/assets/images/ImageUpload.svg" />
                              <h3 class="font-weight-light ma-0">Drag and drop here to upload</h3>
                              <h3 class="font-weight-light ma-0">Or</h3>
                              <h3 class="dropzone-custom-title">Browse</h3>
                            </div>
                          </vue-dropzone>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-col class="text-right" cols="12">
                    <v-btn color="#989898" class="mr-4 white--text" @click="cancel">Cancel</v-btn>
                    <v-btn
                      :disabled="!valid"
                      color="#344452"
                      class="white--text"
                      :loading="loading"
                      @click="save"
                    >{{(lpProfileId) ? 'Update' : 'Save'}}</v-btn>
                  </v-col>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import CommonSection from "@/components/CommonHeader";
import { MediaService, LPProfileService } from "@/services";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import { MEDIATYPE_THUMBNAIL, CLINIC_IMAGE_WIDTH, CLINIC_IMAGE_HEIGHT} from "@/constants";
import { ImageValidateMixin } from "@/mixins";

export default {
  name: "AddLPProfile",
  components: {
    CommonSection,
    quillEditor,
    vueDropzone: vue2Dropzone,
  },
  mixins: [ImageValidateMixin],
  data() {
    var self = this;
    return {
      e1: 1,
      loading: false,
      open: ["public"],
      valid: true,
      lpProfileId: null,
      status: false,
      media: [],
      lpProfile: {
        name: null,
        isActive: false,
        website: null,
        nationality: null,
        cultivationLocation: null,
        // productionFacility: null,
        range: null,
        description: null,
        // isFavourite:false,
      },
      validateUrl: [
        v => !!v || "Website is required!",
        (v) =>
          !v ||
          /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/.test(
            v
          ) ||
          "Your url link is not valid.",
      ],
      emailRules: [
        v => !!v || "E-mail is required!",
        v =>
          /.+@.+\..+/.test(v) || "You have entered an invalid e-mail address."
      ],
      dropzoneOptions: {
        url: `${process.env.VUE_APP_SERVERURL}media`,
        chunking: true,
        addRemoveLinks: true,
        autoProcessQueue: true,
        maxFilesize: 2, // MB
        thumbnailWidth: 300,
        maxFiles: 1,
        headers: {
          Authorization: `Bearer ${store.state.user.token}`,
        },
        dictFileTooBig:"File is too big ({{filesize}}MB). Max filesize: {{maxFilesize}}MB.",
        acceptedFiles: "image/*",
          init() {
            this.on("maxfilesexceeded", function(file) {
              this.removeAllFiles();
              this.addFile(file);
            });
            this.on("addedfile", file => {
            if (file.size > 1024 * 1024 * 2) {
              // not more than 2mb
              this.removeFile(file);
            }
          });
            this.on("thumbnail",(file) => {
              self.validateBannerDimension(file, CLINIC_IMAGE_WIDTH, CLINIC_IMAGE_HEIGHT)
            });
          },
          accept(file, done) {
            self.showError(file, CLINIC_IMAGE_WIDTH, CLINIC_IMAGE_HEIGHT,done)
          }
      },
      editorOption: {
        theme: "snow",
      },
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id !== 'create') { 
        this.lpProfileId = this.$route.params.id
        await this.getLPProfileData();
        await this.uploadedImage();
      }
    },
    async getLPProfileData() {
      let lpProfile;
      if(this.$route.params.id === "create") {     
      lpProfile = await LPProfileService.getLPProfile(this.lpProfileId);
      }
      else{
        lpProfile = await LPProfileService.getLPProfile(this.$route.params.id);
      }
      this.lpProfile.name = lpProfile.data.data[0].name;
      this.lpProfile.website = lpProfile.data.data[0].website;
      this.lpProfile.nationality = lpProfile.data.data[0].nationality;
      this.lpProfile.cultivationLocation = lpProfile.data.data[0].cultivationLocation;
      // this.lpProfile.productionFacility = lpProfile.data.data[0].productionFacility;
      this.lpProfile.range = lpProfile.data.data[0].range;
      this.lpProfile.description = lpProfile.data.data[0].description;
      this.lpProfile.isActive = lpProfile.data.data[0].isActive;
      // this.lpProfile.isFavourite = lpProfile.data.data[0].isFavourite;
      this.media = lpProfile.data.data[0].media;
    },
    beforecomplete(file, xhr, formData) {
      formData.append("mediaType", "image");
      formData.append("moduleType", "education/lpProfile");
      formData.append("mediaSubType", "file");
      formData.append("imageType", MEDIATYPE_THUMBNAIL);
      formData.append("moduleId", this.lpProfileId);
    },
    aftercomplete(file, response) {
      this.$store.dispatch(
        "user/setSnack",
        "LP Profile Image uploaded successfully!"
      );
      this.getLPProfileData();
      this.$store.dispatch("user/setType", "info");
    },
    uploadedImage() {
      if (this.media && this.media.length > 0) {
        this.media.filter((media) => {
          if (media.mediaType == "image") {
            var file = {
              size: media.size,
              name: media.name,
              type: media.type,
            };
            this.$refs.myVueDropzone.manuallyAddFile(file, media.url);
          }
        });
      }
    },
    removeFile(file, error, xhr) {
      if (file.size > 1024 * 1024 * 2) {
        this.$store.dispatch(
          "user/setSnack",
          "Upto 2MB File size is allowed"
        );
        this.$store.dispatch("user/setType", "error");
      }
      this.deletePicture(file);
    },
    async deletePicture(file) {
      try {
        if (file) {
          let mediaId = this.media.filter((media) => {
            if (media.mediaType == "image" && media.name == file.name) {
              return media._id;
            }
          });
          if (mediaId.length > 0) {
            const response = await MediaService.deleteMedia({
              id: mediaId[0]._id,
              body: {
                moduleType: "education/lpProfile",
                moduleId: this.lpProfileId,
              },
            });
            this.getLPProfileData();
            if (response) {
              this.$store.dispatch(
                "user/setSnack",
                "LP Profile image deleted successfully!"
              );
              this.$store.dispatch("user/setType", "info");
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    cancel() {
      this.$router.push("/lp-profile");
    },
    async saveValidate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          const response = await LPProfileService.createLPProfile(this.lpProfile);
          this.loading = false;
          if (response) {
            this.e1 = 2;
            this.lpProfileId = response.data.id;
            this.$store.dispatch(
              "user/setSnack",
              "LP Profile added successfully!"
            );
            this.$store.dispatch("user/setType", "info");
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    async updateValidate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          const response = await LPProfileService.updateLPProfile({
            id: this.lpProfileId,
            object: this.lpProfile,
          });
          this.loading = false;
          if (response) {
            this.e1 = 2;
            this.lpProfileId = response.data.id;
            this.$store.dispatch(
              "user/setSnack",
              "LP Profile updated successfully!"
            );
            this.$store.dispatch("user/setType", "info");
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          this.loading = false;
          this.$router.push("/lp-profile");
          this.$store.dispatch("user/setSnack", `LP Profile ${(this.lpProfileId) ? 'updated' : 'added'} successfully!`);
          this.$store.dispatch("user/setType", "info");
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.main-content .navbar-top {
  display: none !important;
}
</style>